var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseline-layout',{scopedSlots:_vm._u([{key:"container",fn:function(){return [_c('section',{staticClass:"finx-home"},[_c('card-remuneracao')],1)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }